var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 13.07 19.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff9300;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.03,1.49C3.17,.5,4.7,0,6.64,0c1.29,0,2.39,.22,3.31,.67,.92,.45,1.61,1.06,2.08,1.83s.71,1.64,.71,2.6c0,1.13-.28,2.06-.85,2.77-.57,.71-1.23,1.2-1.98,1.45v.1c.98,.33,1.75,.87,2.32,1.62,.57,.75,.85,1.72,.85,2.91,0,1.06-.24,2-.73,2.82s-1.2,1.45-2.14,1.92c-.94,.46-2.05,.7-3.33,.7-2.06,0-3.7-.51-4.93-1.52-1.23-1.01-1.87-2.54-1.94-4.58H4.27c.02,.76,.23,1.35,.64,1.79,.41,.44,1.01,.66,1.8,.66,.67,0,1.19-.19,1.56-.58,.37-.38,.55-.9,.55-1.53,0-.82-.26-1.42-.79-1.79-.52-.37-1.36-.55-2.51-.55h-.82v-3.58h.82c.88,0,1.58-.15,2.12-.45,.54-.3,.81-.84,.81-1.61,0-.62-.17-1.1-.51-1.44-.34-.34-.82-.51-1.42-.51-.65,0-1.14,.2-1.45,.59-.32,.4-.5,.88-.55,1.47H.23c.07-1.84,.67-3.25,1.8-4.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.7a5e90eac3c3373cef5b4d3e84b53e6a.svg";
export { ForwardRef as ReactComponent };